<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "Textarea" });
import Label from "../../elements/label/Label.svelte";
import LabelHint from "../../elements/label-hint/LabelHint.svelte";
import LabelError from "../../elements/label-error/LabelError.svelte";
import { onMount } from "svelte";
import { t } from "svelte-i18n";
import { v4 as uuid } from "uuid";
import "tailwindcss/tailwind.css";
import { handleInputError } from "../../common/validation.js";
export let value;
export let name;
export let label = void 0;
export let hint = void 0;
export let placeholder = void 0;
export let isDisabled = false;
export let isReadonly = false;
export let isRequired = true;
export let minLength = void 0;
export let maxLength = void 0;
let id = "";
let isTouched = false;
let error = null;
const validate = (event) => {
    const TARGET = event.target;
    if (event.type === "input" && !isTouched) {
        return;
    }
    error = handleInputError(TARGET);
};
const trimValue = () => {
    value = typeof value === "string" ? value.trim() : value;
};
const setTouched = (event) => {
    trimValue();
    isTouched = true;
    validate(event);
};
$: value = value === "" ? void 0 : value;
onMount(() => {
    id = uuid();
});
</script>

<div class = 's8-form-row s8-textarea'>

    {#if label !== null || hint !== null}
        <div class = 's8-header'>
            <Label { id } { label } { isDisabled } />
            <LabelHint { id } { hint } { isDisabled } />
        </div>
    {/if}

    <textarea
        bind:value
        on:change = { validate }
        on:input = { validate }
        on:invalid = { setTouched }
        on:blur = { setTouched }
        { id }
        { name }
        placeholder = { $t(placeholder ?? '') }
        maxlength = { maxLength }
        minlength = { minLength }
        required = { isRequired }
        readonly = { isReadonly }
        disabled = { isDisabled }
        class:s8-touched = { isTouched }
        { ...$$restProps }
    />

    <div class = 's8-footer'>
        <LabelError { id } { error } />
    </div>
</div>

<style>

    div.s8-textarea {
        position: relative;
        padding: 3px 0px;
        width: 100%;
        display: flex;
        flex-direction: column;
        row-gap: 2px;
    }

        div.s8-textarea div.s8-header {
            display: flex;
            justify-content: space-between;
            min-height: 10px;
        }

        div.s8-textarea div.s8-footer {
            margin-top: 3px;
            min-height: 10px;
        }

        div.s8-textarea textarea {
            box-sizing: border-box;
            height: 98px;
            width: 100%;
            padding: 10px;
            border: 0px;

            border-radius: 6px;
            background: rgba(39,39,17,0.06);
            box-shadow: inset 0 1px 1px 0 rgba(39,39,17,0.12);
            outline: none;

            font-size: inherit;
            cursor: text;

            transition:
                background-color 0.3s ease-in-out,
                box-shadow 0.3s ease-in-out,
                color 0.3s ease-in-out;
        }

        div.s8-textarea textarea::-moz-placeholder {
                color: rgba(39,39,17,0.36);
                -moz-transition: color 0.3s ease-in-out;
                transition: color 0.3s ease-in-out;
            }

        div.s8-textarea textarea::placeholder {
                color: rgba(39,39,17,0.36);
                transition: color 0.3s ease-in-out;
            }

        div.s8-textarea textarea:focus {
                background: rgba(68,131,95,0.12);
                box-shadow: inset 0 1px 1px 0 rgba(68,131,95,0.24);
            }

        div.s8-textarea textarea:focus::-moz-placeholder {
                    color: rgba(68,131,95,0.48);
                }

        div.s8-textarea textarea:focus::placeholder {
                    color: rgba(68,131,95,0.48);
                }

        div.s8-textarea textarea.s8-touched:invalid:not(:focus) {
                background: rgba(239,35,59,0.12);
                box-shadow: inset 0 1px 1px 0 rgba(239,35,59,0.24);
                color: rgba(239,35,59,1);
            }

        div.s8-textarea textarea.s8-touched:invalid:not(:focus)::-moz-placeholder {
                    color: rgba(239,35,59,0.48);
                }

        div.s8-textarea textarea.s8-touched:invalid:not(:focus)::placeholder {
                    color: rgba(239,35,59,0.48);
                }

        div.s8-textarea textarea:disabled {
                background: rgba(39,39,17,0.04);
                box-shadow: initial;
                color: rgba(39,39,17,0.24);
                cursor: default;
            }

        div.s8-textarea textarea:disabled::-moz-placeholder {
                    color: rgba(39,39,17,0.24);
                }

        div.s8-textarea textarea:disabled::placeholder {
                    color: rgba(39,39,17,0.24);
                }</style>